import React from 'react'
import { Image } from 'react-bootstrap'
import personImage from './person_image.png'

const UserImage = ({
    user = {},
    fluid = true,
}) => {
    const image = user.pictureUrl || personImage
    return (
        <React.Fragment>
            <Image src={image} roundedCircle fluid={fluid} />
        </React.Fragment>
    )
}

export default UserImage